<script setup lang="ts">
import { ref } from 'vue';
import { useRoute } from "vue-router";
const popupRef = ref(null);

const route = useRoute();
const props = defineProps({
  car: { default: {}, type: Object },
  location: { default: {}, type: Object },
  payload: { default: {}, type: Object }
});

const showTipBox = ref(false);

const toggleTipBox = () => {
  showTipBox.value = !showTipBox.value;
};

</script>

<template>
  <div class="item-card">
    <div class="search-grid-label-wrapper"
         v-if="car.vendor_name && car.vendor_name.includes(' (1C)')"
    >
      <div  @mouseover="toggleTipBox"
            @mouseleave="toggleTipBox"
            class="lightning-wrapper"
      >
        <img src="/img/lightning.png" />
      </div>
      <div class="tipbox"
           v-show="showTipBox"
      >
        Эта машина доступна для <strong>мгновенного бронирования</strong>.
        Автомобили без этого знака бронируются <strong>по запросу</strong>. Мы уточняем доступность и сообщаем вам, можно ли завершить бронирование, или предлагаем свободные альтернативы — всё это занимает всего несколько минут.
      </div>
    </div>

    <OneClickPopUp ref="popupRef"
                   :car="car"
                   :locationName="props.location?.searchResult?.pick_up_location_name?.name"
    />

    <div class="item-card__image">
      <nuxt-link
        :to="`/booking?car-id=${car.id}&from-id=${car.pick_up_location_id}&to-id=${car.drop_off_location_id}&from-date=${payload['from-date']}&from-time=${payload['from-time']}&to-date=${payload['to-date']}&to-time=${payload['to-time']}&promocode=${payload['promocode']}&from-original=${payload['from-id']}&to-original=${payload['to-id']}`"
      >
        <img :src="car.model_image" v-if="car.model_image" alt="" />
        <img
          :src="car.images[0].image"
          v-if="!car.model_image && car.images && car.images.length > 0"
          alt=""
        />
      </nuxt-link>
    </div>
    <div class="item-card__content">
      <div class="item-card__name">{{ car.model }}</div>
      <div class="item-card__row">
        <p class="item-card__text">{{ car.engine_capacity }}</p>
        <p class="item-card__text">{{ car.transmission }}</p>
        <p class="item-card__text grey-color">
          {{ car.seats }} {{ $getNumberLabels(car.seats, ["место", "места", "мест"]) }}
        </p>
        <p class="item-card__text grey-color">{{ car.engine_hp }} л.с.</p>
        <p class="item-card__text grey-color">{{ car.year }}</p>
      </div>
      <p class="item-card__text" v-if="car.deposit">
        Депозит: {{ $getFormattedNumber(car.deposit) }}
        <span
          v-show="
            car &&
            car.currency &&
            car.currency.short_title &&
            car.currency.short_title !== null
          "
          >{{ car.currency.short_title }}</span
        >
      </p>
      <div class="item-card__price">
        <p class="item-card__text">
          Стоимость за
          <strong
            >{{ Math.floor(car.rent_period_days) }}
            {{
              $getNumberLabels(Math.floor(car.rent_period_days), ["день", "дня", "дней"])
            }}</strong
          >
        </p>
        <p v-if="car.rate_per_day_old" class="item-card__text old-price">
          <span class="line-through">{{
            $getFormattedNumber(
              car.drop_off_location_fee +
                car.pick_up_location_fee +
                car.rate_per_day_old * Math.floor(car.rent_period_days) +
                car.pickup_out_of_hours_fee +
                car.dropoff_out_of_hours_fee
            )
          }}</span>
          <span
            v-show="
              car &&
              car.currency &&
              car.currency.short_title &&
              car.currency.short_title !== null
            "
            >{{ car.currency.short_title }}</span
          >
        </p>
      </div>
      <div class="item-card__button">
        <nuxt-link
          :to="`/booking?car-id=${car.id}&from-id=${car.pick_up_location_id}&to-id=${car.drop_off_location_id}&from-date=${payload['from-date']}&from-time=${payload['from-time']}&to-date=${payload['to-date']}&to-time=${payload['to-time']}&promocode=${payload['promocode']}&from-original=${payload['from-id']}&to-original=${payload['to-id']}`"
          class="item-card__button-link updated_card_button"
        >
          <span v-if="car.rate_subtotal && car.rate_per_day">{{
            $getFormattedNumber(
              car.drop_off_location_fee +
                car.pick_up_location_fee +
                car.pickup_out_of_hours_fee +
                car.dropoff_out_of_hours_fee +
                car.rate_per_day * Math.floor(car.rent_period_days)
            )
          }}</span>
          <span
            v-show="
              car &&
              car.currency &&
              car.currency.short_title &&
              car.currency.short_title !== null
            "
            >{{ car.currency.short_title }}</span
          >
        </nuxt-link>
      </div>
      <div class="item-card__button">
        <div class="item-card__button-link rent__button"
             @click="popupRef.openPopup"
        >
          Аренда в 1 клик
        </div>
      </div>
    </div>
  </div>
</template>

<style>
  .search-grid-label-wrapper {
    position: relative;
  }
  .search-grid-label-wrapper img {
    width: 30px;
    height: auto;
    position: absolute;
    display: block;
    z-index: 11111;
  }
  .search-grid-label-wrapper .exclamation-mark-wrapper img {
    top: 7px;
  }
  .search-grid-label-wrapper .lightning-wrapper img {
    width: 33px;
    top: -10px;
    right: -10px;
  }
  .search-grid-label-wrapper .tipbox {
    text-align: left;
    width: 100%;
    margin: auto;
    top: 42px;
    right: 2px;
    background-color: #333e50;
    padding: 16px;
    font-size: 14px;
    color: #fff;
    line-height: 1.6;
    position: absolute;
    z-index: 111111111111;
    border-radius: 4px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
  .search-grid-label-wrapper .tipbox::after {
    content: "";
    position: absolute;
    bottom: 100%;
    right: 10px;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent #333e50 transparent;
  }
  .search-grid-label-wrapper .tipbox strong {
    font-weight: bold;
  }
  @media (max-width: 768px) {
    .search-grid-label-wrapper .tipbox {
      font-size: 12px;
    }
  }
</style>